export default __webpack_public_path__ + "static/media/fridge.43f21a79.svg";